module.exports = __webpack_public_path__ + "media/images/os_cara/eduardo-old-362a45cbd67c1281cc2f6e89576b64c6.jpg";